import { mixed, object, string } from 'yup'

import { NewUserStep1, UserSalutationType } from '~api/models'
import { mandatoryField, invalidMailAddress, inputInvalid } from '~shared/translations/yupSchemaErrors'

export const NewUserStep1Schema = object<NewUserStep1>({
  salutation: mixed<UserSalutationType>().oneOf(Object.values(UserSalutationType), inputInvalid).required(mandatoryField),
  firstName: string().required(mandatoryField),
  lastName: string().required(mandatoryField),
  email: string().email(invalidMailAddress).required(mandatoryField),
}).defined()
